import React from 'react';
import { Link } from 'react-router-dom';

import '../css/back-arrow.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

export default function BackArrow(props) {
  return (
    <Link to={`${props.lastPage}`}>
      <FontAwesomeIcon className='back-arrow' icon={faChevronLeft} />
    </Link>
  );
}
